module.exports = __webpack_public_path__ + "img/mtc-main.87d4f7d2.webp";